import { ExperienceTeaser, HowHumnWorks, IntentionField, TheShift, V2Hero } from "../components/v2/HeroJourney";
import { FinalBrand, GlobalNetwork, HumanPossibilities, HumnAiTeaser, IntentionEconomy, LaunchMoment } from "../components/v2/NetworkSections";
import { usePageMeta } from "../lib/usePageMeta";
import { HomepageTeaser } from "../components/features/HomepageTeaser";

export default function Landing() {
  usePageMeta("HUMN — The Ai Social Network", "Tell HUMN what you want to make happen. Meet the right people and turn intentions into real Happenings.");
  return (
    <main data-testid="landing-page">
      <V2Hero />
      <TheShift />
      <IntentionField />
      <HowHumnWorks />
      <HomepageTeaser />
      <ExperienceTeaser />
      <GlobalNetwork />
      <HumanPossibilities />
      <HumnAiTeaser />
      <IntentionEconomy />
      <LaunchMoment />
      <FinalBrand />
    </main>
  );
}